/* Stickers Souq — new-design header on every page except the home page (layout/theme.liquid).
   1) phone menu (as nd-app3.js)   2) header slims down on scroll (as nd-motion6.js)
   3) the cart count in the header follows the real cart: ToyTime's product forms, the cart
      drawer and the sheet builder all talk to /cart/*.js, so after any of those calls the
      count is read again from /cart.js. */
(function () {
  "use strict";

  /* ---- 1) phone menu ---- */
  var burger = document.getElementById("v3-burger");
  var menu = document.getElementById("v3-menu");
  if (burger && menu) {
    var setMenu = function (open) {
      menu.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    };
    burger.addEventListener("click", function () { setMenu(!menu.classList.contains("open")); });
    menu.addEventListener("click", function (e) { if (e.target.closest("a")) setMenu(false); });
  }

  /* ---- 2) header slims down on scroll ---- */
  var header = document.querySelector(".v3-header"), queued = false;
  function frame() { queued = false; if (header) header.classList.toggle("v6-scrolled", scrollY > 40); }
  addEventListener("scroll", function () { if (!queued) { queued = true; requestAnimationFrame(frame); } }, { passive: true });
  frame();

  /* ---- 3) the cart icon opens ToyTime's cart drawer (when the page has one) ---- */
  var cartIcon = document.querySelector("[data-cart-icon]");
  var drawer = document.querySelector("cart-drawer");
  if (cartIcon && drawer && typeof drawer.open === "function" && !/\/cart\/?$/.test(location.pathname)) {
    cartIcon.addEventListener("click", function (e) { e.preventDefault(); drawer.open(cartIcon); });
  }

  /* ---- 4) cart count ---- */
  var count = document.querySelector("[data-cart-count]");
  if (!count || !window.fetch) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function refresh() {
    window.__ndFetch(base + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (String(c.item_count) === count.textContent) return;
        count.textContent = c.item_count;
        if (count.animate) count.animate([{ scale: 1 }, { scale: 1.28 }, { scale: 1 }], { duration: 420, easing: "cubic-bezier(.34,1.56,.64,1)" });
      })
      .catch(function () {});
  }
  window.__ndFetch = window.__ndFetch || window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = window.__ndFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 150); }, function () {});
    return p;
  };
})();
